import store from '@/plugins/app/_config/store.ts'

export default async function(to, from, next) {
	if (!store.getters['wAuth/isLoggedIn']) {
		next('/prihlasenie')
	} else {
		next()
	}
}
